import { render, staticRenderFns } from "./CaseHT.vue?vue&type=template&id=fc4c4f98&scoped=true&"
import script from "./CaseHT.vue?vue&type=script&lang=js&"
export * from "./CaseHT.vue?vue&type=script&lang=js&"
import style0 from "./CaseHT.vue?vue&type=style&index=0&id=fc4c4f98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4c4f98",
  null
  
)

export default component.exports